import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-indicator',
  template: `
    <div class="progress-container">
      <div class="progress-bar" [ngStyle]="progressStyle"></div>
    </div>
  `,
  styles: [
    `
      .progress-container {
        width: 100%;
        height: 3px;
        background: var(--btn-bg-primary);

        .progress-bar {
          height: 3px;
          background: var(--green-primary);
          border-radius: 0px 8px 8px 0px;
        }
      }
    `,
  ],
})
export class ProgressIndicatorComponent {
  @Input() maxProgress: number = 0;
  @Input() set currentProgress(value: number) {
    this.calculateProgress(value);
  }
  progressStyle: any = {};

  calculateProgress(value: number) {
    let progress: string = this.maxProgress > 0 ? `${(100 / this.maxProgress) * value}%` : '0%';
    this.progressStyle = { width: `${progress}` };
  }
}
